module.exports = __webpack_public_path__ + "img/home-landing-health-portal.3357d1bc.svg";